import React, { useMemo } from 'react';
import { getUserData } from '~/store/user/selectors';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { Viewer } from '@grapecity/activereports-react';
import '@grapecity/activereports/styles/ar-js-ui.css';
import '@grapecity/activereports/styles/ar-js-viewer.css';
import reportDeals from './summary-deals-pdf.json';
import { Core } from '@grapecity/activereports';
import { ActiveReportJSKey } from '~/features/dashboard';

export const PreviewDealReport = () => {
    const match = useRouteMatch<{ creatorId: string; acquisitionDealOnly: string }>();
    const creatorId = useMemo(() => Number(match.params.creatorId), [match.params.creatorId]);
    const userData: any = useSelector(getUserData);
    const reportUri: any = JSON.parse(
        JSON.stringify(reportDeals)
            .replaceAll('[API]', String(process.env.REACT_APP_API))
            .replaceAll('[PROJECT_ID]', String(creatorId))
            .replaceAll('[TOKEN]', userData.data?.token)
            .replaceAll('[ACQUISITION_DEAL_ONLY]', match.params.acquisitionDealOnly ? 'true' : 'false')
    );

    Core.setLicenseKey(ActiveReportJSKey);

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <Viewer report={{ Uri: reportUri }} />
        </div>
    );
};
